class TableIconReplacer {
  constructor() {
    this.lang = (document.documentElement.lang || '').toLowerCase();
    this.langPrefix = this.getLangPrefix();
    this.replaceIcons();
  }

  getLang() {
    return (
      document.documentElement.lang ||
      document.querySelector('.srl-article[lang]')?.getAttribute('lang') ||
      'de'
    ).toLowerCase();
  }

  getLangPrefix() {
    switch (this.getLang()) {
      case 'de':
        return 'D';
      case 'en':
        return 'E';
      default:
        return 'D';
    }
  }

  replaceIcons() {
    const tableContainers = document.querySelectorAll('.srl-table-container > table');

    tableContainers.forEach((tableContainer) => {
      const cells = tableContainer.querySelectorAll('td.srl-horizontal-left.ns-horizontal-left');

      cells.forEach((cell) => {
        const span = cell.querySelector('p > span');

        if (span && span.textContent) {
          // Updated regex to support both numeric and non-numeric identifiers (e.g., "bl-01" to "17").
          const regex = new RegExp(`(?:${this.langPrefix})-WEB-Goal-([a-zA-Z0-9-]+)\\.png`, 'g');
          const matches = [];
          let match;

          while ((match = regex.exec(span.textContent)) !== null) {
            matches.push(match);
          }

          if (matches.length > 0) {
            cell.innerHTML = '';

            const imgContainer = document.createElement('div');
            imgContainer.classList.add('img-container');

            matches.forEach((match) => {
              const iconIdentifier = match[1];
              const iconFileName = `${this.langPrefix}-WEB-Goal-${iconIdentifier}.min.svg`;
              const img = document.createElement('img');

              if (document.body.classList.contains('pdf')) {
                img.src = 'https://nswow-ld.nswow.ch/designs/lukb-ld/25.0.27/svg/' + iconFileName;
              } else {
                img.src = '../svg/' + iconFileName;
              }

              img.classList.add('img-sdg');
              imgContainer.appendChild(img);
            });

            cell.appendChild(imgContainer);
          }
        }
      });
    });
  }




}

export default TableIconReplacer;


